import { AtticusLogo } from "@theatticusapp/atticus-shared-components";
import { Box, Typography } from "@mui/material";
import React from "react";

export const AuthHeader = (props?:{text?:string}): JSX.Element => {
  return (
    <Box
      sx={{
        backgroundColor: "#F2F2FF",
        textAlign: "center",
        pt: 4,
        px: 2,
        pb: 6,
        width: "100%",
      }}
    >
      <AtticusLogo title="Atticus" width="100" />
      <Typography variant="h4" sx={{ my: 2 }}>
        {props?.text || "Start getting answers in minutes"}
      </Typography>
    </Box>
  );
};
